import PlanificadorTareaCustomService from 'src/modules/planificadorTareaCustom/planificadorTareaCustomService';
import Errors from 'src/modules/shared/error/errors';
import {getHistory} from 'src/modules/history';

const prefix = 'PLANIFICADORTAREACUSTOM_VIEW';

const planificadorTareaCustomViewActions = {
  FIND_STARTED: `${prefix}_FIND_STARTED`,
  FIND_SUCCESS: `${prefix}_FIND_SUCCESS`,
  FIND_ERROR: `${prefix}_FIND_ERROR`,

  doFind: (id) => async (dispatch) => {
    try {
      dispatch({
        type: planificadorTareaCustomViewActions.FIND_STARTED,
      });

      const record = await PlanificadorTareaCustomService.find(id);

      dispatch({
        type: planificadorTareaCustomViewActions.FIND_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: planificadorTareaCustomViewActions.FIND_ERROR,
      });

      getHistory().push('/planificador-tarea');
    }
  },
};

export default planificadorTareaCustomViewActions;
